import 'katex/dist/katex.min.css';

import { math } from '@streamdown/math';
import { type ComponentProps, memo } from 'react';
import { Streamdown } from 'streamdown';

import { cn } from '@/lib/utils';

import { ResponseLink } from './ResponseLink';

type ResponseProps = ComponentProps<typeof Streamdown>;

const components = { a: ResponseLink };

export const Response = memo(
  ({ className, ...props }: ResponseProps) => (
    <Streamdown
      className={cn(
        'size-full [&>*:first-child]:mt-0 [&>*:last-child]:mb-0',
        className,
      )}
      components={components}
      plugins={{ math }}
      {...props}
    />
  ),
  (prevProps, nextProps) => prevProps.children === nextProps.children,
);

Response.displayName = 'Response';
